export const LMT_ENHCMT_comingBackFromPerfiosReducer = {
  LMT_ENHCMT_comingBackFromPerfios: (state, action) => {
    state.comingBackFromPerfiosFlag = action.payload;
  },
};
